/*
  Sewlume model links (design system v2).
  Loads the shop's model finder index (sewlume_model.finder_index, served by the
  sewlume-finder-index section) once per session and uses it to:
  - link each machine in the product fitment list to its model page, when one exists;
  - collapse long fitment lists after 12 machines, with a "Show all" button;
  - let the fit check resolve model aliases (e.g. "MC6600P" -> Memory Craft 6600P)
    and offer an "All parts for your <model>" link.
  A machine with no model page stays plain text. Nothing here ever says a part
  does not fit: unlisted means "not confirmed".
*/
(function () {
  'use strict';
  // The fitment block and the fit check both include this file; run it once.
  if (window.SewlumeModels) return;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var INDEX_URL = ROOT + '?section_id=sewlume-finder-index';
  var CACHE_KEY = 'sewlume:finder-index:v1';
  var HANDLE = /^[a-z0-9][a-z0-9-]*$/;
  var COLLAPSE_AFTER = 12;

  function norm(value) {
    return String(value == null ? '' : value).normalize('NFKC').toLowerCase().replace(/[\s\-_\/.]+/g, '');
  }
  function stripBrand(key, brandKey) {
    return brandKey && key.indexOf(brandKey) === 0 && key.length > brandKey.length ? key.slice(brandKey.length) : key;
  }

  function build(data) {
    if (!data || data.v !== 1 || !Array.isArray(data.brands)) throw new Error('index shape');
    var byKey = new Map(); // "brand|model" -> entry
    var byAlias = new Map(); // "model" (no brand) -> [entry]
    data.brands.forEach(function (group) {
      if (!group || typeof group.brand !== 'string' || !Array.isArray(group.models)) return;
      var brandKey = norm(group.brand);
      group.models.forEach(function (row) {
        if (!Array.isArray(row) || typeof row[0] !== 'string' || !HANDLE.test(row[0]) || typeof row[1] !== 'string') return;
        var entry = { handle: row[0], name: row[1], brand: group.brand };
        var keys = [norm(row[1])].concat((Array.isArray(row[2]) ? row[2] : []).filter(function (a) { return typeof a === 'string'; }).map(norm));
        keys.forEach(function (k) {
          if (!k) return;
          var m = stripBrand(k, brandKey);
          [brandKey + '|' + m, brandKey + '|' + k].forEach(function (full) { if (!byKey.has(full)) byKey.set(full, entry); });
          var list = byAlias.get(m) || [];
          if (list.indexOf(entry) === -1) list.push(entry);
          byAlias.set(m, list);
          if (k !== m) {
            var withBrand = byAlias.get(k) || [];
            if (withBrand.indexOf(entry) === -1) withBrand.push(entry);
            byAlias.set(k, withBrand);
          }
        });
      });
    });
    return {
      lookup: function (brand, model) {
        var b = norm(brand);
        return byKey.get(b + '|' + stripBrand(norm(model), b)) || null;
      },
      resolve: function (text) {
        var k = norm(text);
        if (k.length < 2) return null;
        var hits = byAlias.get(k);
        return hits && hits.length === 1 ? hits[0] : null;
      }
    };
  }

  var ready = null;
  function load() {
    if (ready) return ready;
    ready = new Promise(function (resolve, reject) {
      try {
        var cached = sessionStorage.getItem(CACHE_KEY);
        if (cached) { resolve(build(JSON.parse(cached))); return; }
      } catch (e) {}
      fetch(INDEX_URL, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('index ' + r.status); return r.text(); })
        .then(function (html) {
          var script = new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-sw-finder-index]');
          if (!script) throw new Error('index missing');
          var data = JSON.parse(script.textContent);
          if (typeof data === 'string') data = JSON.parse(data);
          var idx = build(data);
          try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch (e) {}
          resolve(idx);
        })
        .catch(reject);
    });
    ready.catch(function () { ready = null; });
    return ready;
  }

  function modelUrl(entry) {
    return ROOT + 'collections/' + entry.handle;
  }

  function collapse(root) {
    root.querySelectorAll('.fitment__models').forEach(function (list) {
      var items = list.querySelectorAll('.fitment__model');
      if (items.length <= COLLAPSE_AFTER || list.dataset.slmCollapsed) return;
      list.dataset.slmCollapsed = '1';
      for (var i = COLLAPSE_AFTER; i < items.length; i++) items[i].classList.add('is-more');
      list.classList.add('is-collapsed');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fitment__more';
      btn.textContent = 'Show all ' + items.length + ' machines';
      btn.addEventListener('click', function () { list.classList.remove('is-collapsed'); btn.remove(); });
      list.insertAdjacentElement('afterend', btn);
    });
    var search = root.querySelector('#fitment-search');
    if (search) search.addEventListener('input', function () {
      if (!search.value.trim()) return;
      root.querySelectorAll('.fitment__models.is-collapsed').forEach(function (l) { l.classList.remove('is-collapsed'); });
      root.querySelectorAll('.fitment__more').forEach(function (b) { b.remove(); });
    });
  }

  function linkFitment(root, idx) {
    root.querySelectorAll('.fitment__model[data-brand]').forEach(function (li) {
      if (li.querySelector('a')) return;
      var entry = idx.lookup(li.dataset.brand, li.dataset.m);
      var span = li.querySelector('span');
      if (!entry || !span) return;
      var a = document.createElement('a');
      a.className = 'fitment__link';
      a.href = modelUrl(entry);
      a.textContent = span.textContent;
      span.replaceWith(a);
    });
  }

  window.SewlumeModels = { load: load, url: modelUrl, norm: norm };

  function init() {
    var fit = document.getElementById('fitment');
    if (fit) collapse(fit);
    var wanted = fit && fit.querySelector('.fitment__model[data-brand]');
    if (!wanted) return;
    var go = function () { load().then(function (idx) { linkFitment(fit, idx); }).catch(function () {}); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
      }, { rootMargin: '600px 0px' });
      io.observe(fit);
    } else {
      go();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
